import { render } from "./OIDCReturnPage.vue?vue&type=template&id=557fdb66&ts=true"
import script from "./OIDCReturnPage.vue?vue&type=script&lang=ts"
export * from "./OIDCReturnPage.vue?vue&type=script&lang=ts"

import "./OIDCReturnPage.vue?vue&type=style&index=0&id=557fdb66&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__